import React from "react";
import styles from "./notificationTemplates.module.css";
import successIcon from "../../icons/success.svg";

const Success = ({
  children,
  successIconProps = {
    size: 16,
  },
}) => {
  return (
    <div className={[styles.template, styles.Success].join(" ")}>
      <img
        src={successIcon}
        alt="success"
        {...successIconProps}
        width={successIconProps.size}
        height={successIconProps.size}
      />
      {children}
    </div>
  );
};

export default Success;
